export const ADMIN = 'A';
export const RESEARCHER = 'RC';
export const SUPER_RESEARCHER = 'SRC';
export const DOCTOR = 'D';
export const PATIENT = 'P';
export const TECHNICIAN = 'DT';
export const SUPER_TECHNICIAN = 'SDT';

export const FHIR_VALUE_ROLES = {
  [RESEARCHER]: {
    code: {
      coding: [
        {
          code: 'RC',
          display: 'Research Coordinator',
        },
      ],
      text: 'Research Coordinator',
    },
  },
  [SUPER_RESEARCHER]: {
    code: {
      coding: [
        {
          code: 'SRC',
          display: 'Super Research Coordinator',
        },
      ],
      text: 'Super Research Coordinator',
    },
  },
  [DOCTOR]: {
    code: {
      coding: [
        {
          code: 'D',
          display: 'Doctor',
        },
      ],
      text: 'Doctor',
    },
  },
  [TECHNICIAN]: {
    code: {
      coding: [
        {
          code: 'DT',
          display: 'Device Clinician',
        },
      ],
      text: 'Device Clinician',
    },
  },
  [SUPER_TECHNICIAN]: {
    code: {
      coding: [
        {
          code: 'SDT',
          display: 'Super Device Clinician',
        },
      ],
      text: 'Super Device Clinician',
    },
  },
};
